export function sliceString(string?: string | null, targetLength = 60) {
  if (!string) {
    return '';
  }

  if (string.length <= targetLength) {
    return string;
  }

  return string.slice(0, targetLength) + '...';
}
